module.exports = __webpack_public_path__ + "img/save.0e4ec1ad.png";